import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { get, post } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const getSystemAnnouncementList = createAsyncThunk(
  "getSystemAnnouncementList",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(`${URL.GET_SYSTEM_ANNOUNCEMENT_LIST}`, data, {
        signature,
        nonce,
      });
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const addSystemAnnouncementApi = createAsyncThunk(
  "addSystemAnnouncementApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.ADD_SYSTEM_ANNOUNCEMENT, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message || "Something went wrong!", null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const systemAnnouncementDetailsApi = createAsyncThunk(
  "systemAnnouncementDetailsApi",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await get(
        URL.GET_SYSTEM_ANNOUNCEMENT_DETAILS + "/" + data?._id,
        { signature, nonce },
      );
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      toast.error(error?.message || "Something went wrong!");
      callBack && callBack(error?.message || "Something went wrong!");

      return Thunk.rejectWithValue(error);
    }
  },
);

export const cancelSystemAnnouncementApi = createAsyncThunk(
  "cancelSystemAnnouncementApi",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      let response = await post(URL.CANCEL_SYSTEM_ANNOUNCEMENT, data, {
        signature,
        nonce,
      });
      if (response.status === "failure") {
        toast.error(response?.message);
        return Thunk.rejectWithValue(response?.message);
      }
      toast.success(response?.message);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message || "Something went wrong!", null);
      return Thunk.rejectWithValue(error);
    }
  },
);

// export const cancelScheduledSystemAnnouncementApi = createAsyncThunk(
//   "cancelScheduledSystemAnnouncementApi",
//   async ({ data, callback }, Thunk) => {
//     try {
//       const { signature, nonce } = await getValuesSocketData();
//       let response = await post(URL.CANCEL_SCHEDULED_TIME_SYSTEM_ANNOUNCEMENT, data, {
//         signature,
//         nonce,
//       });
//       if (response.status === "failure") {
//         toast.error(response?.message);
//         return Thunk.rejectWithValue(response?.message);
//       }
//       toast.success(response?.message);
//       callback && callback(null, response);
//       return response;
//     } catch (error) {
//       toast.error(error?.message || "Something went wrong!");
//       callback && callback(error.message || "Something went wrong!", null);
//       return Thunk.rejectWithValue(error);
//     }
//   },
// );
